import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="m11.97 5.282-4.727 4.727L4.53 7.297l-1.06 1.06 3.773 3.774 5.787-5.789-1.06-1.06Z M13.657 13.657A8 8 0 1 1 2.343 2.342a8 8 0 0 1 11.314 11.315Zm-1.06-1.06a6.5 6.5 0 1 1-9.193-9.193 6.5 6.5 0 0 1 9.192 9.192Z"
    />
  </IconWrapper>
)

export default ActionValidIconSmall
